import { render, staticRenderFns } from "./NegativeBalanceHead.vue?vue&type=template&id=676926a1&scoped=true"
import script from "./NegativeBalanceHead.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceHead.vue?vue&type=script&lang=js"
import style0 from "./NegativeBalanceHead.vue?vue&type=style&index=0&id=676926a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676926a1",
  null
  
)

export default component.exports